import React from 'react';
import { ImageReservationNumber } from '../../../../../assets/images';
import { TranslationUtils, SmartEmailFieldEnricher, SmartPhoneFieldEnricher } from '../../../../../utils';
import './QuestionPanel.scss';

type QuestionPanelProps = { email?: string; phoneNumber?: string; name?: string };

export const QuestionPanel: React.FC<QuestionPanelProps> = (props: QuestionPanelProps) => {
    if (!props.email && !props.phoneNumber) {
        return null;
    }
    const textKey =
        props.email && props.phoneNumber
            ? 'pal_res_question_panel_text'
            : props.email
            ? 'pal_res_question_panel_text_email_only'
            : 'pal_res_question_panel_text_phone_only';

    return (
        <div className="question-panel">
            <div className="question-image d-none d-sm-block">
                <ImageReservationNumber />
            </div>
            <div className="question-text">
                <h6 className="body-bold" tabIndex={0}>
                    {TranslationUtils.get('need_help')}
                </h6>
                <p className={'body-regular'}>
                    <span
                        tabIndex={0}
                        dangerouslySetInnerHTML={{
                            __html: TranslationUtils.get(textKey, {
                                name: props.name ?? '',
                                email: SmartEmailFieldEnricher.from(props.email, 'html')?.toString(),
                                phoneNumber: SmartPhoneFieldEnricher.from(props.phoneNumber, 'html')?.toString(),
                            }),
                        }}
                    />
                </p>
            </div>
        </div>
    );
};
